import { useMemo } from "react";
import { locationToLocalization } from "@Locales/localizationMapping";
import CheerzApiProvider from "@Providers/CheerzApiProvider";
import { getMetaContent } from "@Utils/meta";

const useCheerzApiProvider = (): CheerzApiProvider => {
  const localeSlug = locationToLocalization(window.location).locale;

  return useMemo(() => {
    const csrfToken = getMetaContent("csrf-token");
    if (!csrfToken) {
      throw new Error("CSRF Token not found");
    }

    return new CheerzApiProvider(localeSlug, csrfToken);
  }, [localeSlug]);
};

export default useCheerzApiProvider;
